function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEmotionLoveFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9 16C1.9 8.225 8.225 1.9 16 1.9c7.775 0 14.1 6.324 14.1 14.1 0 7.775-6.326 14.1-14.1 14.1S1.9 23.775 1.9 16zm1.988 0C3.888 22.677 9.322 28.11 16 28.11S28.112 22.678 28.112 16c0-6.678-5.434-12.111-12.112-12.111-6.679 0-12.112 5.433-12.112 12.111z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.922 15.97s2.724-2 2.724-3.568c0-1.088-.603-1.847-1.467-1.847-.56 0-.998.28-1.244.774-.242-.514-.686-.806-1.259-.806-.863 0-1.467.76-1.467 1.847 0 1.581 2.713 3.6 2.713 3.6zM22.323 10.555c-.56 0-.998.28-1.244.774-.242-.513-.686-.806-1.259-.806-.863 0-1.466.76-1.466 1.848 0 1.58 2.712 3.6 2.712 3.6s2.724-2.001 2.724-3.568c0-1.088-.603-1.848-1.467-1.848z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.47 18.974a.994.994 0 111.988 0c0 3.724-3.224 6.385-7.458 6.385-4.238 0-7.458-3.076-7.458-6.385a.994.994 0 111.989 0c0 1.054.58 2.152 1.559 2.99.978.837 2.347 1.407 3.91 1.407 1.573 0 2.942-.392 3.915-1.135.97-.74 1.555-1.835 1.555-3.262z",
    fill: props.color
  }));
}

export default SvgIconEmotionLoveFilled;